import { IViewConfiguration } from "@formant/core/model/IViewConfiguration";
import { IViewConfigurationMap } from "@formant/core/model/IViewConfigurationMap";
import { StreamType } from "@formant/core/model/StreamType";

export function findConfiguration<T extends StreamType>(
    configuration: IViewConfiguration[],
    streamName: string,
    type: T,
) {
    return configuration.find(
        _ => _.type === type && _.streamName === streamName,
    )?.configuration as T extends keyof IViewConfigurationMap
        ? IViewConfigurationMap[T]
        : never;
}
